import { FelaCSS, FelaCSSWithCustomSelectors, transition } from '@bridebook/ui';

interface IArgs {
  top?: number;
}

interface IStyles {
  wrapper: FelaCSSWithCustomSelectors;
  tab: FelaCSS;
}

// Persistent class name for the Sticky component
export const STICKY_BASE_CLASS_NAME = 'sticky-tab-navigation';
// Sticky component class name that is only applied if the item is stickied to top
export const STICKY_STICKIED_CLASS_NAME = 'sticky-tab-navigation-sticky';

const styles = ({ top }: IArgs): IStyles => ({
  wrapper: {
    overflow: 'hidden',

    // react-sticky needs to be updated to latest version to refactor this
    '> div': {
      [`> .${STICKY_BASE_CLASS_NAME}`]: {
        position: 'initial',
        zIndex: 4,
        top: top ? `${top}px !important` : 0,
        overflow: 'hidden',
        transition: `visibility ${transition.fast} ease-in-out`,
      },

      [`> .${STICKY_BASE_CLASS_NAME}.${STICKY_STICKIED_CLASS_NAME}`]: {
        position: 'fixed',
      },
    },
  } as FelaCSSWithCustomSelectors,

  tab: {
    fontDefault: 14,
    paddingHorizontal: 4,
    paddingVertical: 2,
  },
});

export default styles;
